import * as React from 'react';
import { ReactElement } from 'react';

interface IProps {
  label?: string;
  statusText?: string;
  id?: string;
}

// `form-label` stays as a bare hook for library-nav's stylesheet, which sets
// its own margin and line-height via `.library-nav__search .form-label`.
const Label = ({ label, statusText, id }: IProps): ReactElement => (
  <div className="flex justify-between">
    <label
      className="form-label mb-2 text-base font-medium tracking-[0.04em] text-form-label"
      htmlFor={id}>
      {label}
    </label>
    <span className="text-base">{statusText}</span>
  </div>
);

export default Label;
